import { STOP_TYPE } from './type';
import { STOP_STATUS } from './status';

// Backend categories for POD images
export const POD_CATEGORIES = {
    DELIVERY: 'DELIVERY',
    OUTBOUND: 'OUTBOUND',
};

export const isDropoffFailedStop = (stop) => stop?.type === STOP_TYPE.DROPOFF && stop?.status === STOP_STATUS.FAILED;

export const POD_CATEGORY_LABELS = {
    [POD_CATEGORIES.DELIVERY]: 'Delivery',
    [POD_CATEGORIES.OUTBOUND]: 'Outbound',
};

const DELIVERY_FAILED_LABEL = 'Delivery Failed';

// The DELIVERY PODs of a failed dropoff stop are labelled "Delivery Failed" — it is only a
// display name, the category stored on the image and sent to the backend stays DELIVERY.
export const getPODCategoryLabel = (category, stop) =>
    category === POD_CATEGORIES.DELIVERY && isDropoffFailedStop(stop)
        ? DELIVERY_FAILED_LABEL
        : POD_CATEGORY_LABELS[category] || category;
